import { useContext } from "react";
import { stores } from "@/context/stores";

export const useStores = () => useContext(stores);
